import React, { Component } from 'react'
import Icon from './Icon'
import propTypes from 'prop-types'

class ClientRecords extends Component {
  static propTypes = {
    gray: propTypes.string
  }

  render () {
    const color = this.props.gray ? '#7E8DA2' : '#FFFFFF'
    return (
      <Icon {...this.props}>
        <svg width='24' height='24' viewBox='0 0 24 24'>
          <path
            fill={color}
            fillRule='evenodd'
            d='M10,4 L10,0 L0,0 L0,18 L20,18 L20,4 L10,4 L10,4 Z M4,16 L2,16 L2,14 L4,14 L4,16 L4,16 Z M4,12 L2,12 L2,10 L4,10 L4,12 L4,12 Z M4,8 L2,8 L2,6 L4,6 L4,8 L4,8 Z M4,4 L2,4 L2,2 L4,2 L4,4 L4,4 Z M8,16 L6,16 L6,14 L8,14 L8,16 L8,16 Z M8,12 L6,12 L6,10 L8,10 L8,12 L8,12 Z M8,8 L6,8 L6,6 L8,6 L8,8 L8,8 Z M8,4 L6,4 L6,2 L8,2 L8,4 L8,4 Z M18,16 L10,16 L10,14 L12,14 L12,12 L10,12 L10,10 L12,10 L12,8 L10,8 L10,6 L18,6 L18,16 L18,16 Z M16,8 L14,8 L14,10 L16,10 L16,8 L16,8 Z M16,12 L14,12 L14,14 L16,14 L16,12 L16,12 Z'
            transform='translate(2 3)'
          />
        </svg>
      </Icon>
    )
  }
}

export default ClientRecords
